module.exports = __webpack_public_path__ + "img/arrow_left.7a6551c4.png";